import { Lock } from 'lucide-react';

interface Props {
  pmsSource: string | null | undefined;
}

export function SyncManagedFooter({ pmsSource }: Props) {
  const vendorLabel = pmsSource && pmsSource.trim().length > 0 ? pmsSource : 'the property management system';
  return (
    <div className="flex items-center gap-2 rounded-lg border border-border bg-muted/40 px-4 py-3 text-sm text-muted-foreground">
      <Lock className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>This property is sync-managed. Make changes in {vendorLabel} to update fields here.</span>
    </div>
  );
}
